
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/books",
      function () {
        return require("private-next-pages/users/[id]/books.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/books"])
      });
    }
  